 
import React, { useState, useContext } from "react";
import { NavLink } from 'react-router-dom';
import { langContext } from './../context/langContext';
import es from './../img/spain.png';
import en from './../img/united-kingdom.png';
import Titulo from './../components/Titulo';
import "../components/NavBar.css";

function Navbar() {
  const idioma = useContext(langContext);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar-custom sticky-top">

      {/* LEFT: logo */}
      <div className="navbar-left">
        <NavLink exact="true" to="/" className="nav-logo navbar-brand">
          <img src='./img/logo.png' height='80' alt="logo" />
        </NavLink>
      </div>

      {/* CENTER: titulo */}
      <div className="navbar-center">
        <Titulo />
      </div>

      {/* RIGHT: banderas (desktop) y boton hamburguesa (mobile) */}
      <div className="navbar-right">
        <div className="banderas-desktop">
          <button onClick={() => idioma.establecerLenguaje('es-es')} aria-label="ES">
            <img src={es} alt="es" />
          </button>
          <button onClick={() => idioma.establecerLenguaje('en-US')} aria-label="EN">
            <img src={en} alt="en" />
          </button>
        </div>

      </div>

      {/* Si usas un menú mobile desplegable lo podrías renderizar acá.
         Por ahora dejamos el título siempre visible; el botón sólo es estético/opcional. */}
    </nav>
  );
}

export default Navbar;
